import { render, staticRenderFns } from "./OldReservationTable.vue?vue&type=template&id=c5fda052&scoped=true"
import script from "./OldReservationTable.vue?vue&type=script&lang=js"
export * from "./OldReservationTable.vue?vue&type=script&lang=js"
import style0 from "./OldReservationTable.vue?vue&type=style&index=0&id=c5fda052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fda052",
  null
  
)

export default component.exports